import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import styles from "./LicenseCard.module.css"; // keep if you're using custom CSS module

const LicenseCard = ({ license, onEdit, onDelete }) => {
  return (
    <Box
      sx={{
        border: '1px solid #ddd',
        borderRadius: 2,
        p: 2,
        maxWidth: 500,
        width: '100%',
        margin: '0 auto',
        backgroundColor: '#fff',
        boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="h6">
          {license.license_type === 'broker' ? 'Broker License' : 'Realtor License'}
        </Typography>
        <Box
          sx={{
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            backgroundColor: license.is_verified ? '#d1fae5' : '#fef2f2',
            color: license.is_verified ? '#065f46' : '#991b1b',
            fontSize: '0.75rem',
            fontWeight: 600,
          }}
        >
          {license.is_verified ? 'Verified' : 'Under Review'}
        </Box>
      </Box>

      <Typography variant="body1">
        <strong>State:</strong> {license.state}
      </Typography>

      <Typography variant="body1" sx={{ mb: 2 }}>
        <strong>License #:</strong> {license.license_number}
      </Typography>

      {license.license_url && (
        <img
          src={license.license_url}
          alt="License"
          style={{
            height: '140px',
            width: '100%',
            objectFit: 'cover',
            borderRadius: '8px',
            boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
            marginBottom: '16px',
          }}
        />
      )}

      <Box display="flex" justifyContent="flex-end" gap={1}>
        <Button onClick={() => onEdit(license)} variant="outlined">
          Edit
        </Button>
        <Button onClick={() => onDelete(license.id)} color="error" variant="outlined">
          Delete
        </Button>
      </Box>
    </Box>
  );
};

export default LicenseCard;
